import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import './index.scss';
import {
    ButtonPrimary,
    ErrorFeedbackScreen,
    SuccessFeedbackScreen,
    skinVars,
    useWindowSize,
} from '@telefonica/mistica';
import { useLocation, useNavigate } from 'react-router-dom';
import navigateParams from '../../../../utils/navigation/navigateParams';
import PersonalData from '../../personalData';
import { TrackingEvents } from '../../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../../utils/navigation/controlDevices';

export interface UpdatePasswordFeedbackType {
    fromDesktop?: any;
    setComponentSelected?: any;
    stateDesktop?: any;
    errDesktop?: any;
}

export const UpdatePasswordFeedback = ({
    fromDesktop,
    setComponentSelected,
    stateDesktop,
    errDesktop,
}: UpdatePasswordFeedbackType) => {
    const { t } = useTranslation();
    const { state } = useLocation();
    const navigate = useNavigate();
    const stateFeedback = fromDesktop ? stateDesktop : state?.stateFeedback;
    const err = fromDesktop ? errDesktop : state?.err;
    const { trackingScreenView } = new TrackingEvents();
    const size = useWindowSize();

    const sendToNative = (url: string, title?: string) => {
        if (fromDesktop) {
            setComponentSelected(<PersonalData></PersonalData>);
        } else {
            const type = 'modeFlow-backgroundBlue';
            const queryParams = {};
            if (navigateParams(type, url, queryParams)) {
                navigate(url);
            }
        }
    };

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
    }, []);

    return (
        <div
            className='feedbackChangesPassword-page'
            style={{
                background:
                    stateFeedback === 'SUCCESS'
                        ? size.width < 1024 || size.height < 550
                            ? skinVars.colors.backgroundBrand
                            : ''
                        : skinVars.colors.background,
            }}
        >
            {stateFeedback === 'SUCCESS' ? (
                <SuccessFeedbackScreen
                    title={t('changesPasswordInfoFeedbackTitle')}
                    description={t('changesPasswordInfoFeedbackDescription')}
                    primaryButton={
                        <ButtonPrimary
                            onPress={() => {
                                sendToNative('/profile');
                            }}
                        >
                            {t('buttonUnderstoodFeedback')}
                        </ButtonPrimary>
                    }
                ></SuccessFeedbackScreen>
            ) : (
                <ErrorFeedbackScreen
                    title={err.title}
                    description={err.localizedDescription}
                    errorReference={'Código de error: ' + `${err.id}`}
                    primaryButton={
                        <ButtonPrimary
                            onPress={() => {
                                sendToNative('/profile');
                            }}
                        >
                            {t('buttonUnderstoodFeedback')}
                        </ButtonPrimary>
                    }
                ></ErrorFeedbackScreen>
            )}
        </div>
    );
};

export default UpdatePasswordFeedback;
